<div class="modules-app">
  <div class="figure"></div>
  <div class="popover">
    <div class="contain-popover">
      <div
        class="elements"
        *ngFor="let item of elements"
        (click)="selected(item)"
      >
        <img
          *ngIf="item.logo"
          class="icons"
          [src]="item.logo"
          onerror="this.onerror=null;this.src='https://cdn.mango-soft.com/default-image.svg';"
        />
        <img
          *ngIf="!item.logo"
          class="icons"
          src="https://cdn.mango-soft.com/default-image.svg"
        />
        <span class="text" [title]="item.customNameModule">
          {{ item.customNameModule }}
        </span>
      </div>
    </div>
  </div>
</div>
